import api from "./api";

export const getCanonicalStageId = ticket => {
  const stageIds = (ticket?.tags || [])
    .filter(tag => Number(tag.kanban) === 1)
    .map(tag => Number(tag.id))
    .filter(id => Number.isSafeInteger(id) && id > 0)
    .sort((first, second) => first - second);

  return stageIds.length ? stageIds[0] : null;
};

export const normalizeStageTarget = laneId => {
  if (laneId === "none" || laneId === "" || laneId === null) return null;

  const id = Number(laneId);
  if (!Number.isSafeInteger(id) || id <= 0) {
    throw new Error("Etapa inválida.");
  }

  return id;
};

export const buildKanbanParams = ({ filters, queueIds = [], afterId }) => {
  const params = {};
  const searchParam = String(filters.searchParam || "").trim();

  if (filters.dateStart && filters.dateEnd) {
    params.dateStart = filters.dateStart;
    params.dateEnd = filters.dateEnd;
  }
  if (searchParam) params.searchParam = searchParam;
  if (filters.status) params.status = filters.status;
  if (filters.stageId) params.stageId = filters.stageId;
  if (filters.users && filters.users.length) params.users = JSON.stringify(filters.users);
  if (filters.unread) params.withUnreadMessages = "true";
  if (queueIds.length) params.queueIds = JSON.stringify(queueIds);
  if (afterId) params.afterId = afterId;

  return params;
};

export const mergeTicketPages = (current, incoming) => {
  const incomingIds = new Set(incoming.map(ticket => Number(ticket.id)));
  return [
    ...incoming,
    ...current.filter(ticket => !incomingIds.has(Number(ticket.id)))
  ].sort((first, second) => Number(second.id) - Number(first.id));
};

export const fetchKanbanTickets = ({ filters, queueIds, afterId }) =>
  api.get("/ticket/kanban", {
    timeout: 20000,
    params: buildKanbanParams({ filters, queueIds, afterId })
  });

export const fetchKanbanStages = () => api.get("/tag/kanban/", { timeout: 20000 });

export const fetchKanbanContext = ticketId => api.get(`/tickets/${ticketId}/kanban-context`, { timeout: 20000 });

export const moveKanbanTicket = ({
  ticketId,
  stageTagId,
  expectedVersion,
  requestId
}) => api.patch(`/tickets/${ticketId}/kanban-stage`, {
  stageTagId,
  expectedVersion,
  requestId
}, { timeout: 20000 });

export const fetchTicketState = ticketId => api.get(`/tickets/${ticketId}`);

export const fetchKanbanHistory = (ticketId, beforeId) =>
  api.get(`/tickets/${ticketId}/kanban-history`, {
    timeout: 20000,
    params: beforeId ? { beforeId } : undefined
  });
